import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt } from 'react-icons/fa';
import './style.scss';

export interface DepartmentDatePickerProps {
  defaultDate?: Date;
  onDateChanged?: (date: Date) => void;
}

export function DepartmentDatePicker({ defaultDate = new Date(), onDateChanged }: DepartmentDatePickerProps) {
  // const employeeInfo = useAppSelector(selectEmployeeInfo);
  const [startDate, setStartDate] = useState(defaultDate);

  function handleDateChanged(newDate: Date) {
    setStartDate(newDate);
    onDateChanged && onDateChanged(newDate);
  }

  const CustomInput = React.forwardRef((props: any, ref: any) => {
    return (
      <div style={{ position: 'relative' }}>
        <FaCalendarAlt style={{ position: 'absolute', top: '8px', left: '10px' }} onClick={props.onClick} />
        <input
          className="form-control"
          onClick={props.onClick}
          style={{ paddingLeft: '32px' }}
          value={props.value}
          onChange={props.onChange}
          type="text"
        />
      </div>
    );
  });

  return (
    <div className="ams-month-picker d-flex align-items-center">
      <ReactDatePicker
        className="ams-month-picker__input"
        popperPlacement="bottom"
        selected={startDate}
        onChange={handleDateChanged}
        dateFormat="yyyy/MM/dd"
        // showMonthYearPicker

        customInput={<CustomInput />}
      />
    </div>
  );
}
